import { Component, OnInit } from "@angular/core";
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import "rxjs/add/operator/merge";
import { Utils } from "src/app/common/utils";
import { AllPatient } from "src/app/models/patient";
import { Appointment } from "../../models/appointment";
import { PatientD } from "../../models/Pdetails";
import { Checkin } from "../../models/scheckin";
import { VproService } from "./../../service/vpro/vpro.service";
import { Location } from '@angular/common';
import { sortBy } from "underscore";
import { TrimFormValuesService } from "src/app/common/trimmingForm";

@Component({
  selector: "app-checkin",
  templateUrl: "./checkin.component.html",
  styleUrls: ["./checkin.component.css"],
})
export class CheckinComponent implements OnInit {
  public model: any;
  public model2: any;
  acheckin: any[] = [];
  physicians = [];
  apdata = [];
  chkpat: any;
  pappoint = [];
  Ecode: number;
  innerHtml: string = "";
  appointment = new Appointment();
  checkin = new Checkin();
  patientd = new PatientD();
  allpat = new AllPatient();
  dataValue: boolean;
  searchphy: any;
  submitted = false;
  pat: string;
  phy: string;
  appoint: {};
  router: any;
  data: any;
  activeindex = -1;
  title: string;
  message: string;
  name: any;
  isCheckInLoading: boolean;
  aid: any;
  apid: any;
  appointName = [];
  dataOfPatient: any;
  birth: any;
  patientIdOf: any;
  patientIdBasedData = [];
  isError: boolean;
  chkdob: any;
  org_code: any;
  defaultDr = Utils.DEFAULTDR;
  dateFormat = Utils.DATE_FORMAT;
  val: any = { chkdob: '', model: '', model2: '' };
  activeBtn = 'all';
  constructor(
    private postService: VproService,
    private calendar: NgbCalendar,
    private utils: Utils,
    private location: Location,
    private trimFormValuesService: TrimFormValuesService
  ) { }

  ngOnInit() {
    this.org_code = localStorage.getItem("orgcode");
    this.displaycheckin(this.val);
  }

  /**function displayAppoint for select the data*/
  displaycheckin(values) {
    console.log("**********************", this.activeBtn);
    this.activeBtn = values;

    let online_checkin
    if (values === 'INPERSON') {
      online_checkin = false;
    }
    if (values === 'ONLINE') {
      online_checkin = true;
    }
    this.isError = false;

    try {
      if (values.chkdob) {
        let inputDate = new NgbDate(
          values.chkdob.year,
          values.chkdob.month,
          values.chkdob.day
        );
        if (
          this.calendar.isValid(inputDate)
        ) {
          values.chkdob = `${values.chkdob.year}-${values.chkdob.month}-${values.chkdob.day}`;
        } else {
          this.isError = true;
        }
      }
      if (!this.isError) {
        this.isCheckInLoading = true;
        let data = {
          org_code: this.org_code,
          apdate: values.chkdob,
          pat_name: values.model,
          doc_name: values.model2,
          apttype: Utils.OFFLINE_APPOINTMENTS,
          online_checkin: online_checkin
        };

        console.log("datadatad", data);
        let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));

        if (this.utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this.utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)) {
          data["drid"] = parseInt(localStorage.getItem("uid"));
        }
        console.log("Search  1", data);
        this.trimFormValuesService.trimValues(data);
        console.log("Search  2", data);
        this.postService.displayAppoint(data).subscribe(
          (appointments: any[]) => {
            this.acheckin = appointments;
            console.log("this.acheckin", this.acheckin);

            this.acheckin.forEach(x => {
              const apdate = new Date(x.apdate);
              const currentDate = new Date();
              const currentHours = currentDate.getHours();
              currentDate.setHours(currentHours);
              if (x.endtime) {
                const timeParts = x.endtime.split(':');
                if (timeParts.length >= 2) {
                  const hours = parseInt(timeParts[0], 10);
                  const minutes = parseInt(timeParts[1], 10);
                  const seconds = timeParts.length > 2 ? parseInt(timeParts[2], 10) : 0;
                  apdate.setHours(hours, minutes, seconds, 0);
                }
              }
              if (apdate.getTime() === currentDate.getTime()) {
                x.currentDate = true;
                console.log("apdate is equal to current time");
              } else if (apdate < currentDate) {
                console.log("apdate is before current time");
                x.currentDate = false;
              } else {
                console.log("apdate is after current time");
                x.currentDate = true;
              }
            });
            console.log("this.acheckin", this.acheckin);

            if (data.doc_name) {
              this.acheckin = this.acheckin.filter(docname =>

                docname.physician_first_name.toLowerCase().includes(data.doc_name.toLowerCase())
                || docname.physician_last_name.toLowerCase().includes(data.doc_name.toLowerCase())
                //   docname.physician_first_name == input.doc_name

                || docname.physician_first_name.toString().concat(" ", docname.physician_last_name.toString()).toLowerCase().includes(data.doc_name.toLowerCase()))


            }
            this.acheckin = this.acheckin.filter(list => list.dob != null)
            // this.acheckin = sortBy(this.acheckin, 'aptime'); // Data Sorter via underscore.js
            // this.acheckin = sortBy(this.acheckin, 'apdate'); // Data Sorter via underscore.js




            let norecmsg = (this.acheckin && this.acheckin.length == 0)

              ? this.innerHtml = "<h3 align='center'>No appointments</h3>" : this.innerHtml = "";

            this.isCheckInLoading = false;
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (excep) {
      console.log(excep);
    }
  }




  /**function patientSelection for select the patient */
  patientSelection(data) {
    this.patientIdOf = data;
    this.patientIdBasedData = [];
    this.acheckin.filter((element) => {
      if (element["patid"] == this.patientIdOf) {
        this.patientIdBasedData.push(element);
      }
    });
  }

  deleteFieldValue(index) {
    this.acheckin.splice(index, 1);
  }
  public formatTime(value) {
    let res;
    if (value && typeof value === "string") {
      let keys = value.split(":");
      res = this.getTime(keys[0]) + " : " + keys[1] + " " + this.getFormat(keys[0]);
    }
    return res;
  }

  getTime(time) {
    if (parseInt(time) > 12) {
      time = (parseInt(time) - 12).toString();
    }
    return time;
  }

  getFormat(value) {
    if (parseInt(value) < 12) {
      return 'AM';
    } else {
      return 'PM';
    }
  }
  getback() {
    this.location.back();
  }
}
